<template>
    <div class="search-control">
        <input v-model="query" placeholder="Search" type="text" class="form-control rounded search">
        <button v-if="query" class="clear icon" @click="clear">
            <svg viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="currentColor" />
            </svg>
        </button>
    </div>
</template>

<script>
export default {
  name: 'search',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      query: this.value,
      _searchTimer: null
    }
  },
  watch: {
    value (val) {
      this.query = val
    },
    query (val) {
      this.$emit('input', val)
      clearTimeout(this._searchTimer)
      this._searchTimer = setTimeout(() => {
        this.$emit('search', val)
      }, 500)
    }
  },
  methods: {
    clear () {
      this.query = ''
      this.$el.querySelector('input').focus()
    }
  }
}
</script>

<style scoped lang="scss">
$clear-btn-offset: 8px;
$clear-btn-size: 32px;

.search-control {
    display: flex;
    align-items: center;
    position: relative;

    input {
        flex: 1;

        &:has(+ button) {
            padding-right: calc(#{$clear-btn-offset} * 2 + #{$clear-btn-size});
        }
    }

    .clear {
        position: absolute;
        right: $clear-btn-offset;
        width: $clear-btn-size;
        height: $clear-btn-size;
        aspect-ratio: 1;

        border: none;
        background-color: inherit;
        cursor: pointer;

        svg{
            width: 18px;
            height: 18px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// search.vue?0d7a6bc6